import { createForm, getForms } from "../../services/FormService";
import {
  FORM_CREATE_CONFIRMED_ACTION,
  FORM_CREATE_FAILED_ACTION,
  FORMS_CONFIRMED_ACTION,
  FORMS_FAILED_ACTION,
} from "./actionTypes";
export function formsListAction() {
  return (dispatch) => {
    getForms()
      .then((response) => {
        dispatch(confirmedFormsAction(response));
      })
      .catch((error) => {
        const errorMessage = error.response
          ? error.response.data
          : "Network Error";
        dispatch(formsFailedAction(errorMessage));
      });
  };
}

export function createFormAction(form, navigate) {
  return (dispatch) => {
    createForm(form)
      .then((response) => {
        dispatch(formCreateAction(response));
        if (typeof navigate != "undefined") {
          navigate("/dashboard");
        }
      })
      .catch((error) => {
        const errorMessage = error.response
          ? error.response.data
          : "Network Error";
        dispatch(formCreateFailAction(errorMessage));
      });
  };
}

export function formCreateAction(payload) {
  return {
    type: FORM_CREATE_CONFIRMED_ACTION,
    payload,
  };
}

export function formCreateFailAction(data) {
  return {
    type: FORM_CREATE_FAILED_ACTION,
    payload: data,
  };
}

export function confirmedFormsAction(payload) {
  return {
    type: FORMS_CONFIRMED_ACTION,
    payload,
  };
}

export function formsFailedAction(data) {
  return {
    type: FORMS_FAILED_ACTION,
    payload: data,
  };
}
